import { useState, useEffect, useRef } from "react";
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard";
import ModalConfirm from '../ModalConfirm';
import { useNavigate } from "react-router-dom";
import ModalAgregarCliente from "./ModalAgregarCliente";

const Clientes = () => {    
    const [personas, setPersonas] = useState([]);
    const [filteredPersonas, setFilteredPersonas] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [editandoPersonaId, setEditandoPersonaId] = useState(null);
    const [personaEditada, setPersonaEditada] = useState({});
    const [personaSeleccionada, setPersonaSeleccionada] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [personaAEliminar, setPersonaAEliminar] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const [showModalAgregar, setShowModalAgregar] = useState(false);
    const formularioRef = useRef(null);
    const inputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        obtenerPersonas();
    }, []);

   

    const obtenerPersonas = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "personas"
            });


            const soloClientes = response.data.data[0].filter(persona => persona.tipo_persona === "Cliente");
            setPersonas(soloClientes);
            setFilteredPersonas(soloClientes); // Inicializar la lista filtrada
        } catch (error) {
            console.log(error);
        }
    };

    const handleSearch = (e) => {
        const search = e.target.value.toLowerCase();
        setSearchTerm(search);
        const filtered = personas.filter(persona =>
            Object.values(persona).some(value =>
                value.toString().toLowerCase().includes(search)
            )
        );
        setFilteredPersonas(filtered);
    };


    const editarPersona = (idPersona, personaActual) => {
        setEditandoPersonaId(idPersona);
        setPersonaEditada(personaActual);
        setPersonaSeleccionada(idPersona);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(0, 0);
            }
        }, 0);
    };

    const guardarPersonaEditada = async (idPersona) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "personas",
                idpersona: idPersona,
                ...personaEditada
            });
            setEditandoPersonaId(null);
            setPersonaSeleccionada(null);
            obtenerPersonas();
        } catch (error) {
            console.log(error);
        }
    };

    const confirmarEliminarPersona = (idPersona) => {
        setShowConfirmModal(true);
        setPersonaAEliminar(idPersona);
    };

    const ejecutarEliminarPersona = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "personas",
                idpersona: personaAEliminar
            });
            setShowConfirmModal(false);
            obtenerPersonas();
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <>
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar esta persona?"
                onConfirm={ejecutarEliminarPersona}
                onCancel={() => setShowConfirmModal(false)}
            />

            <ModalAgregarCliente
                show={showModalAgregar}
                onClose={() => setShowModalAgregar(false)}
                onPersonaAgregada={obtenerPersonas} // Refresca la lista de personas al agregar
            />            
                <>
                    <Dasboard  />

                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <h2 className="text-2xl font-bold mb-6 mt-4">Clientes</h2>

                                {/* Barra de búsqueda */}
                                <input
                                    type="text"
                                    placeholder="Buscar cliente..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className="border rounded-lg p-2 mb-4 w-full"
                                />

                                <ul>
                                    {filteredPersonas.map((persona) => (
                                        <li key={persona.idpersona} className="border-4 p-4 rounded-lg mb-4 cursor-pointer"
                                            onClick={() => setPersonaSeleccionada(persona.idpersona)}>

                                            <div className="relative">
                                                {personaSeleccionada === persona.idpersona ? (
                                                    <>
                                                        {/* Botón para cerrar detalles */}
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setPersonaSeleccionada(null);
                                                                setEditandoPersonaId(null);
                                                            }}
                                                            className="absolute top-[-1rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                        >
                                                            &times;
                                                        </button>

                                                        {/* Detalles completos cuando se selecciona el cliente */}
                                                        {editandoPersonaId === persona.idpersona ? (
                                                            <div className="flex flex-col">

                                                                <h3 className="font-semibold">Nombre:</h3>
                                                                <input
                                                                    type="text"
                                                                    ref={inputRef}
                                                                    value={personaEditada.nombre}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, nombre: e.target.value })}
                                                                    placeholder="Nombre"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={50}
                                                                />

                                                                <h3 className="font-semibold">Razón Social:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.razonsocial}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, razonsocial: e.target.value })}
                                                                    placeholder="Razón Social"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={50}
                                                                />

                                                                <h3 className="font-semibold">Dirección:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.direccion}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, direccion: e.target.value })}
                                                                    placeholder="Dirección"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={250}
                                                                />

                                                                <h3 className="font-semibold">Código Postal:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.codigopostal}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        if (/^\d*$/.test(input)) { // Permite solo números
                                                                            setPersonaEditada({ ...personaEditada, codigopostal: input });
                                                                        }
                                                                    }}
                                                                    placeholder="Código Postal"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={8} // Limita el campo a 5 caracteres
                                                                />


                                                                <h3 className="font-semibold">Teléfono:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.telefono}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        if (/^\d*$/.test(input)) { // Solo permite números
                                                                            setPersonaEditada({ ...personaEditada, telefono: input });
                                                                        }
                                                                    }}
                                                                    placeholder="Teléfono"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={10} // Limita el campo a 10 caracteres
                                                                />


                                                                <h3 className="font-semibold">Fax:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.fax}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, fax: e.target.value })}
                                                                    placeholder="Fax"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={20}
                                                                />

                                                                <h3 className="font-semibold">Email:</h3>
                                                                <input
                                                                    type="email"
                                                                    value={personaEditada.email}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, email: e.target.value })}
                                                                    placeholder="Email"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={30}
                                                                />

                                                                <h3 className="font-semibold">RFC:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.rfc}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, rfc: e.target.value })}
                                                                    placeholder="RFC"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={20}
                                                                />

                                                                <h3 className="font-semibold">Crédito:</h3>
                                                                <input
                                                                    type="number"
                                                                    value={personaEditada.credito}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, credito: e.target.value })}
                                                                    placeholder="Crédito"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={50}
                                                                />

                                                                <h3 className="font-semibold">Banco:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.nombrebanco}
                                                                    onChange={(e) => setPersonaEditada({ ...personaEditada, nombrebanco: e.target.value })}
                                                                    placeholder="Nombre del Banco"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={20}
                                                                />

                                                                <h3 className="font-semibold">Número de Cuenta:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.nocuenta}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        if (/^\d*$/.test(input)) { // Permite solo números
                                                                            setPersonaEditada({ ...personaEditada, nocuenta: input });
                                                                        }
                                                                    }}
                                                                    placeholder="Número de Cuenta"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={20}
                                                                />

                                                                <h3 className="font-semibold">Clabe interbancaria:</h3>
                                                                <input
                                                                    type="text"
                                                                    value={personaEditada.cuentaclave}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        if (/^\d*$/.test(input)) { // Permite solo números
                                                                            setPersonaEditada({ ...personaEditada, cuentaclave: input });
                                                                        }
                                                                    }}
                                                                    placeholder="Clabe interbancaria"
                                                                    className="border rounded-lg p-2 mb-2"
                                                                    maxLength={20} // Limita la clave a 20 caracteres
                                                                />


                                                                <div className="flex mt-4">
                                                                    <button onClick={() => guardarPersonaEditada(persona.idpersona)}
                                                                        className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-40">Guardar</button>
                                                                    <button onClick={() => setEditandoPersonaId(null)}
                                                                        className="bg-gray-500 text-white rounded px-2 py-1 w-40">Cancelar</button>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col">
                                                                <span><strong>Nombre:</strong> {persona.nombre}</span>
                                                                <span><strong>Razón Social:</strong> {persona.razonsocial}</span>
                                                                <span><strong>Dirección:</strong> {persona.direccion}</span>
                                                                <span><strong>Código Postal:</strong> {persona.codigopostal}</span>
                                                                <span><strong>Teléfono:</strong> {persona.telefono}</span>
                                                                <span><strong>Fax:</strong> {persona.fax}</span>
                                                                <span><strong>Email:</strong> {persona.email}</span>
                                                                <span><strong>RFC:</strong> {persona.rfc}</span>
                                                                <span><strong>Crédito:</strong> {persona.credito}</span>
                                                                <span><strong>Banco:</strong> {persona.nombrebanco}</span>
                                                                <span><strong>Número de Cuenta:</strong> {persona.nocuenta}</span>
                                                                <span><strong>Clave de la Cuenta:</strong> {persona.cuentaclave}</span>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    // Solo muestra el nombre si no está seleccionado
                                                    <div className="flex flex-col">
                                                        <span><strong>{persona.nombre}</strong></span>
                                                    </div>
                                                )}
                                            </div>

                                            {personaSeleccionada === persona.idpersona && !editandoPersonaId && (
                                                <>
                                                    <div className="flex items-center mt-2">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                editarPersona(persona.idpersona, persona);
                                                            }}
                                                            className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                        >
                                                            Editar Persona
                                                        </button>

                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                confirmarEliminarPersona(persona.idpersona);
                                                            }}
                                                            className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-red-500"
                                                        >
                                                            Borrar Persona
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                                {!mostrarFormulario && (
                                    <button
                                        onClick={() => setShowModalAgregar(true)}
                                        className="bg-blue-500 text-white rounded px-4 py-2 mb-4 hover:bg-blue-400"
                                    >
                                        Agregar nuevo cliente
                                    </button>
                                )}
                            </div>
                        </div>
                    </main>
                </>             
        </>
    );

};

export default Clientes;
